import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import SmoothScroll from "@/components/vu/SmoothScroll";
import StickyCTA from "@/components/vu/StickyCTA";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App min-h-screen text-[#FFF4E8]">
            <SmoothScroll>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route path="/terms" element={<TermsOfService />} />
                    </Routes>
                </BrowserRouter>
                <StickyCTA />
                <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#14100C", border: "1px solid #2A231C", color: "#FFF4E8", borderRadius: "12px" } }} />
            </SmoothScroll>
        </div>
    );
}
export default App;